import { LitElement, html, css } from 'lit';

class DashboardVersionList extends LitElement {
  static styles = css`
    :host { display: block; }
    .version-list-container { display: flex; flex-direction: column; gap: 16px; width: 100%; }

    .version-card {
      background: #ffffff;
      border: 1px solid #e5e7eb;
      border-left: 6px solid #d1d5db;
      border-radius: 12px;
      padding: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    }

    .version-card:hover {
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -2px rgba(0, 0, 0, 0.025);
      transform: translateY(-2px);
    }

    .status-draft { border-left-color: #9ca3af; }
    .status-preparing { border-left-color: #3b82f6; }
    .status-prepared { border-left-color: #10b981; }
    .status-published { border-left-color: #059669; background-color: #f0fdf4; }
    .status-rejected { border-left-color: #ef4444; background-color: #fef2f2; }

    .v-left { display: flex; flex-direction: column; gap: 8px; }
    .v-title-row { display: flex; align-items: center; gap: 16px; }

    .v-version {
      font-family: ui-monospace, SFMono-Regular, Consolas, monospace;
      font-size: 20px; font-weight: 800; color: #111827; letter-spacing: -0.025em;
    }

    .badge {
      padding: 4px 12px; font-size: 12px; font-weight: 700; border-radius: 20px;
      display: inline-flex; align-items: center; gap: 6px; white-space: nowrap;
    }

    .badge-gray { background-color: #f3f4f6; color: #4b5563; border: 1px solid #e5e7eb;}
    .badge-blue { background-color: #dbeafe; color: #1d4ed8; border: 1px solid #bfdbfe;}
    .badge-green { background-color: #d1fae5; color: #047857; border: 1px solid #a7f3d0;}
    .badge-red { background-color: #fee2e2; color: #b91c1c; border: 1px solid #fecaca;}

    .v-meta { font-size: 13px; color: #6b7280; display: flex; align-items: center; gap: 16px; font-weight: 500; }
    .v-meta i { opacity: 0.7; }

    /* アクションボタンのグループ化レイアウト */
    .v-right { display: flex; align-items: center; gap: 12px; }
    .action-group-main { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
    .action-group-sub { display: flex; align-items: center; gap: 8px; }
    .action-divider { width: 1px; height: 24px; background: #e5e7eb; }
    
    .action-link { display: flex; text-decoration: none; }
    .action-link button { width: 100%; }

    button {
      display: inline-flex; align-items: center; justify-content: center; gap: 6px;
      padding: 8px 14px; font-size: 13px; font-weight: 600; border: 1px solid transparent;
      border-radius: 6px; cursor: pointer; transition: all 0.2s ease; white-space: nowrap;
    }

    .btn-primary { background-color: #3b82f6; color: white; box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2); }
    .btn-primary:hover:not(:disabled) { background-color: #2563eb; transform: translateY(-1px); }

    .btn-success { background-color: #10b981; color: white; box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);}
    .btn-success:hover:not(:disabled) { background-color: #059669; transform: translateY(-1px); }

    .btn-outline { background-color: white; border-color: #d1d5db; color: #374151; box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05); }
    .btn-outline:hover:not(:disabled) { background-color: #f3f4f6; }

    .btn-icon { padding: 8px; background-color: transparent; color: #6b7280; border: 1px solid transparent; }
    .btn-icon:hover:not(:disabled) { background-color: #e5e7eb; color: #111827; }
    .btn-icon.danger:hover:not(:disabled) { background-color: #fef2f2; color: #dc2626; border-color: #fca5a5; }

    button:disabled { opacity: 0.5; cursor: not-allowed; box-shadow: none; }

    .status-preparing-text { color:#3b82f6; font-size:13px; font-weight:bold; padding: 0 8px; white-space: nowrap; }

    .progress-circle-small {
      border: 2px solid rgba(255,255,255,0.3); border-top: 2px solid currentColor;
      border-radius: 50%; width: 12px; height: 12px; animation: spin 1s linear infinite;
    }

    .welcome-onboarding {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 50px 20px;
      background: #ffffff;
      border: 2px dashed #a7f3d0; /* 緑系の枠線 */
      border-radius: 16px;
      text-align: center;
      box-shadow: 0 4px 15px rgba(0,0,0,0.03);
    }
    .onboarding-icon {
      font-size: 48px;
      margin-bottom: 16px;
      background: #ecfdf5;
      width: 96px;
      height: 96px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      color: #10b981;
    }
    /* タイトルなどの共通クラスはDashboardAppListと合わせる */
    .onboarding-title { font-size: 1.5rem; font-weight: 800; color: #1f2937; margin: 0 0 10px 0; }
    .onboarding-desc { color: #6b7280; margin: 0 0 30px 0; line-height: 1.6; }
    .step-indicator { display: flex; align-items: center; gap: 12px; margin-bottom: 35px; flex-wrap: wrap; justify-content: center; }
    .step { padding: 8px 16px; border-radius: 20px; font-size: 13px; font-weight: bold; background: #f3f4f6; color: #9ca3af; }
    .step.active { background: #10b981; color: #ffffff; box-shadow: 0 2px 8px rgba(16, 185, 129, 0.4); }
    .step.done { background: #d1fae5; color: #059669; }
    .step-arrow { color: #d1d5db; font-size: 14px; }
    .btn-start-large {
      background: linear-gradient(135deg, #10b981 0%, #059669 100%);
      color: white; border: none; padding: 14px 28px; border-radius: 12px; font-size: 16px; font-weight: bold; cursor: pointer; display: inline-flex; align-items: center; gap: 10px; transition: transform 0.2s, box-shadow 0.2s;
    }
    .btn-start-large:hover { transform: translateY(-2px); box-shadow: 0 8px 15px rgba(16, 185, 129, 0.3); }

    @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

    .empty-state { padding: 30px 20px; text-align: center; color: #6b7280; font-size: 14px; }

    /* --- オンボーディング導線用スタイル --- */
    .onboarding-banner {
      background: linear-gradient(to right, #eff6ff, #e0e7ff);
      border: 1px solid #bfdbfe;
      border-radius: 12px;
      padding: 20px;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      gap: 20px;
      box-shadow: 0 4px 6px -1px rgba(59, 130, 246, 0.1);
      animation: slideDown 0.5s ease-out;
    }
    .onboarding-banner-icon {
      font-size: 32px;
      color: #3b82f6;
      background: white;
      width: 60px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      box-shadow: 0 2px 4px rgba(0,0,0,0.05);
      flex-shrink: 0;
    }
    .onboarding-banner-content h3 {
      margin: 0 0 8px 0;
      color: #1e3a8a;
      font-size: 1.1rem;
    }
    .onboarding-banner-content p {
      margin: 0;
      color: #475569;
      font-size: 0.95rem;
      line-height: 1.5;
    }
    .step-indicator-mini {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 12px;
    }
    .step-mini {
      padding: 4px 10px;
      border-radius: 12px;
      font-size: 11px;
      font-weight: bold;
    }
    .step-mini.done { background: #d1fae5; color: #059669; }
    .step-mini.active { background: #3b82f6; color: white; box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3); }
    .step-mini-arrow { color: #9ca3af; font-size: 10px; }

    /* ボタンを目立たせる波紋アニメーション */
    .btn-pulse {
      animation: pulse-ring 2s infinite;
      position: relative;
    }
    @keyframes pulse-ring {
      0% { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.7); }
      70% { box-shadow: 0 0 0 10px rgba(59, 130, 246, 0); }
      100% { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0); }
    }
    @keyframes slideDown {
      from { opacity: 0; transform: translateY(-10px); }
      to { opacity: 1; transform: translateY(0); }
    }

    /* モバイル向けレスポンシブ対応 */
    @media (max-width: 768px) {
      .version-card {
        flex-direction: column;
        align-items: stretch;
        gap: 16px;
        padding: 16px;
      }
      .v-left {
        padding-bottom: 12px;
        border-bottom: 1px dashed #e5e7eb;
      }
      .v-right {
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
        justify-content: flex-start;
      }
      .action-group-main {
        width: 100%;
      }
      /* メインボタン群は2列に並べて押しやすくする */
      .action-group-main > *, .action-group-main .action-link {
        flex: 1 1 calc(50% - 4px);
        min-width: 130px; 
      }
      .action-group-main button {
        width: 100%;
      }
      .action-divider {
        display: none; /* スマホでは不要なため非表示 */
      }
      .action-group-sub {
        justify-content: flex-end; /* 右寄せ、または space-evenly */
        width: 100%;
        gap: 8px;
      }
      .action-group-sub .btn-icon {
        flex: 1; /* アイコンを等幅に広げる */
        max-width: 60px; /* 大きくなりすぎないように制限 */
        border: 1px solid #e5e7eb; /* 境界線を明示 */
      }

      .onboarding-banner {
        flex-direction: column;
        text-align: center;
        gap: 15px;
      }
      .step-indicator-mini {
        justify-content: center;
      }
    }
  `;

  static properties = {
    versions: { type: Array },
    selectedApp: { type: Object },
    identKey: { type: String },
    envDevUrlBase: { type: String },
    isDev: { type: Boolean }
  };

  VersionStatus = {
    DRAFT: { value: 'draft', text: '非公開', colorClass: 'badge-gray', borderClass: 'status-draft', icon: 'fa-lock' },
    PREPARING: { value: 'preparing', text: '審査待ち', colorClass: 'badge-blue', borderClass: 'status-preparing', icon: 'fa-paper-plane' },
    REJECTED: { value: 'rejected', text: '審査却下', colorClass: 'badge-red', borderClass: 'status-rejected', icon: 'fa-triangle-exclamation' },
    PREPARED: { value: 'prepared', text: '準備完了', colorClass: 'badge-green', borderClass: 'status-prepared', icon: 'fa-check' },
    PUBLISHED: { value: 'published', text: '公開中', colorClass: 'badge-green', borderClass: 'status-published', icon: 'fa-globe' },
  };

  firstUpdated() {
    const fontAwasomeStyle = document.querySelector("link[rel='stylesheet'][data-name='fontawesomev6']");
    if (fontAwasomeStyle) {
      const fontAwasomeStyleClone = fontAwasomeStyle.cloneNode(true);
      fontAwasomeStyleClone.removeAttribute('disabled');
      this.shadowRoot.insertBefore(fontAwasomeStyleClone, this.shadowRoot.firstChild);
    }
  }

  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    let sizeInMB = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    return `${sizeInMB.toLocaleString()} ${sizes[i]}`;
  }

  getStatusInfo(statusValue) {
    return Object.values(this.VersionStatus).find(v => v.value === statusValue) || this.VersionStatus.DRAFT;
  }

  _dispatch(action, version) {
    this.dispatchEvent(new CustomEvent('version-action', {
      detail: { action, appKey: this.selectedApp.appKey, version: version.version, versionObj: version },
      bubbles: true,
      composed: true
    }));
  }

  render() {
    if (!this.selectedApp) return html``;

    const appVersions = (this.versions || []).filter(v => v.appKey === this.selectedApp.appKey);
    if (appVersions.length === 0) {
      return html`
        <div class="welcome-onboarding">
          <div class="onboarding-icon"><i class="fa-solid fa-code-branch"></i></div>
          <h2 class="onboarding-title">アプリの枠組みができました！</h2>
          <p class="onboarding-desc">
            次に、実際に開発を行うための「バージョン」を作成します。<br>
            バージョンを作成すると、エディタを起動できるようになります。
          </p>
          
          <div class="step-indicator">
            <div class="step done"><i class="fa-solid fa-check"></i> アプリ作成</div>
            <div class="step-arrow"><i class="fa-solid fa-chevron-right"></i></div>
            <div class="step active">2. エディタ起動</div>
          </div>

          <button class="btn-start-large" @click=${() => this.dispatchEvent(new CustomEvent('trigger-create-version', { bubbles: true, composed: true }))}>
            <i class="fa-solid fa-plus"></i> 最初のバージョンを作成する
          </button>
        </div>
      `;
    }

    // 初回作成時（バージョンが1つで、1.0.0で、draft状態）を判定
    const isFirstTime = appVersions.length === 1 &&
      appVersions[0].version === '1.0.0' &&
      appVersions[0].status === this.VersionStatus.DRAFT.value;

    return html`
      <div class="version-list-container">
          
          <!-- 初回時のみ案内バナーを表示 -->
          ${isFirstTime ? html`
            <div class="onboarding-banner">
              <div class="onboarding-banner-icon"><i class="fa-solid fa-laptop-code"></i></div>
              <div class="onboarding-banner-content">
                <div class="step-indicator-mini">
                  <div class="step-mini done"><i class="fa-solid fa-check"></i> 1. アプリの作成</div>
                  <div class="step-mini-arrow"><i class="fa-solid fa-chevron-right"></i></div>
                  <div class="step-mini active">2. エディタ起動</div>
                </div>
                <h3>準備が完了しました！</h3>
                <p>最初のバージョン「1.0.0」が自動的に作成されました。<br>
                下の<strong>「エディタ」ボタン</strong>をクリックして、アプリの中身を作り始めましょう。</p>
              </div>
            </div>
          ` : ''}

          ${appVersions.map(version => {
      const statusInfo = this.getStatusInfo(version.status);
      const isPreparing = version.status === this.VersionStatus.PREPARING.value;

      return html`
              <div class="version-card ${statusInfo.borderClass}">
                <div class="v-left">
                  <div class="v-title-row">
                    <span class="v-version">v ${version.version}</span>
                    <span class="badge ${statusInfo.colorClass}">
                      <i class="fa-solid ${statusInfo.icon}"></i> ${statusInfo.text}
                      ${isPreparing ? html`<div class="progress-circle-small"></div>` : ''}
                    </span>
                  </div>
                  <div class="v-meta">
                    <span title="ディスク使用量"><i class="fa-solid fa-hard-drive"></i> ${this.formatBytes(version.diskSize || 0)}</span>
                  </div>
                </div>
                <div class="v-right">
                  ${this.renderActions(version, isFirstTime)}
                </div>
              </div>
            `;
    })}
      </div>
    `;
  }

  renderActions(version, isFirstTime = false) {
    const s = version.status;
    const previewUrl = this.isDev ? `${this.envDevUrlBase}${this.identKey}/${this.selectedApp.appKey}/${version.version}/` : `/${this.identKey}/${this.selectedApp.appKey}/${version.version}/`;

    // isFirstTime が true の時だけパルスアニメーションのクラスを付与
    const pulseClass = isFirstTime ? 'btn-pulse' : '';

    const btnEditor = html`<button class="btn-primary ${pulseClass}" @click=${() => this._dispatch('editor', version)}><i class="fa-solid fa-laptop-code"></i> エディタ</button>`;
    const btnPreview = html`<a href="${previewUrl}" class="action-link" target="_blank" rel="noopener noreferrer"><button class="btn-outline"><i class="fa-solid fa-arrow-up-right-from-square"></i> 確認</button></a>`;
    const btnSubmit = html`<button class="btn-outline" style="color:#10b981; border-color:#10b981;" @click=${() => this._dispatch('status_preparing', version)}><i class="fa-solid fa-paper-plane"></i> 審査申請</button>`;
    const btnPublish = html`<button class="btn-success" @click=${() => this._dispatch('status_published', version)}><i class="fa-solid fa-globe"></i> 公開する</button>`;
    const btnUnpublish = html`<button class="btn-outline" style="color:#ef4444; border-color:#fca5a5;" @click=${() => this._dispatch('status_draft', version)}><i class="fa-solid fa-lock"></i> 非公開へ</button>`;
    const btnBackToPrepared = html`<button class="btn-outline" @click=${() => this._dispatch('status_prepared', version)}><i class="fa-solid fa-clock-rotate-left"></i> 公開停止</button>`;
    const btnReason = html`<button class="btn-outline" style="color:#ef4444; border-color:#fca5a5;" @click=${() => this._dispatch('reason', version)}><i class="fa-solid fa-circle-info"></i> 理由</button>`;

    const btnDL = html`<button class="btn-icon" title="DL (10PP)" @click=${() => this._dispatch('download', version)}><i class="fa-solid fa-download"></i></button>`;
    const btnEdit = html`<button class="btn-icon" title="名前変更" @click=${() => this._dispatch('edit', version)}><i class="fa-solid fa-pen"></i></button>`;
    const btnCopy = html`<button class="btn-icon" title="複製" @click=${() => this._dispatch('duplicate', version)}><i class="fa-solid fa-copy"></i></button>`;
    const btnDelete = html`<button class="btn-icon danger" title="削除" @click=${() => this._dispatch('delete', version)}><i class="fa-solid fa-trash"></i></button>`;

    let mainActions = '';
    let subActions = html`${btnDL} ${btnCopy}`; // 共通

    if (s === this.VersionStatus.DRAFT.value) {
      mainActions = html`${btnEditor} ${btnPreview} ${btnSubmit}`;
      subActions = html`${btnDL} ${btnEdit} ${btnCopy} ${btnDelete}`;
    } else if (s === this.VersionStatus.REJECTED.value) {
      mainActions = html`${btnEditor} ${btnReason} ${btnSubmit}`;
      subActions = html`${btnDL} ${btnEdit} ${btnCopy} ${btnDelete}`;
    } else if (s === this.VersionStatus.PREPARED.value) {
      mainActions = html`${btnPublish} ${btnUnpublish}`;
      subActions = html`${btnDL} ${btnCopy}`;
    } else if (s === this.VersionStatus.PUBLISHED.value) {
      mainActions = html`${btnBackToPrepared} ${btnUnpublish}`;
      subActions = html`${btnDL} ${btnCopy}`;
    } else if (s === this.VersionStatus.PREPARING.value) {
      mainActions = html`<span class="status-preparing-text">審査中...</span>`;
      subActions = html`${btnCopy}`;
    }

    return html`
          <div class="action-group-main">${mainActions}</div>
          <div class="action-divider"></div>
          <div class="action-group-sub">${subActions}</div>
        `;
  }
}
customElements.define('dashboard-version-list', DashboardVersionList);